import React from 'react'
import clsx from 'clsx'
import { AddCircle, CloseCircle, Eye } from 'iconsax-react'
import { useTheme } from '@mui/material'

import Tooltip from '@SonarCX/components/atoms/Tooltip'
import MediaAvatar from '@SonarCX/components/atoms/MediaAvatar'
import UserSearchDropdown from '@SonarCX/components/molecules/UserSearchDropdown'
import { sortByName } from '@SonarCX/utilities'

const WatchersSection = ({
  classes,
  values,
  removeUser,
  canEdit,
  canSearchUser,
  allUsers,
  handleChange
}) => {
  const theme = useTheme()
  const sortedWatchers = values.watchers
    ? values.watchers
        .map(id => {
          const user = allUsers[id]
          if (!user) return null
          return { ...user }
        })
        .filter(Boolean)
        .sort(sortByName)
        .map(i => i.id)
    : []
  return (
    <div
      className={clsx(
        classes.center,
        classes.label,
        classes.mobile,
        classes.container
      )}
    >
      <span className={clsx(classes.center, classes.label)}>
        <Eye size={theme.size.base} variant='Bulk' color='#B64FCD' /> WATCHERS
      </span>

      <div className={classes.center}>
        {sortedWatchers.map(id => {
          const user = allUsers[id]

          if (!user) {
            return null
          }

          return (
            <Tooltip key={id} title={user?.name ?? ''} arrow>
              <div className={classes.dismiss}>
                <MediaAvatar key={id} user={user} className={classes.avatar} />
                {(canSearchUser || canEdit) && (
                  <CloseCircle
                    size={theme.size.sm}
                    variant='Bulk'
                    color='grey'
                    onClick={() => removeUser('watchers', user)}
                    className='close'
                  />
                )}
              </div>
            </Tooltip>
          )
        })}

        {canEdit && canSearchUser ? (
          <UserSearchDropdown
            prevSelected={[]}
            selected={null}
            onSelect={id => handleChange('watchers')({ target: { value: id } })}
            limit={10}
            disablePortal
          >
            <div className={classes.center}>
              <AddCircle size={theme.size.base} variant='Bulk' color='grey' />
              Add
            </div>
          </UserSearchDropdown>
        ) : values.watchers.length ? null : (
          <div className={classes.noPermission}>No watchers</div>
        )}
      </div>
    </div>
  )
}

export default WatchersSection
